<div class="jobcard-label" [ngStyle]="{color: labelColor ? labelColor : '', 'opacity': isDisabled ? '0.5' : '1'}">{{ label }}</div>
<div class="p-inputgroup">
    <span *ngIf="icon" class="input-icon">
        <daz-icon [color]="iconColor" [name]="icon" [size]="'20px'"></daz-icon>
    </span>

    <p-autoComplete #inputRef class="hub-input" [ngClass]="{'hub-icon' : icon, 'invalid': required && !value}"
        [(ngModel)]="value" (input)="handleInputChange($event)" [placeholder]="placeholder" [suggestions]="suggestions"
        [disabled]="isDisabled" [autofocus]="autofocus" [field]="field" (completeMethod)="onCompleteMethod($event)"
        [forceSelection]="forceSelection"
        [minLength]="minLength"
        [showEmptyMessage]="false"
        (onSelect)="onSelectMethod($event)" field="address">
    </p-autoComplete>

    <span *ngIf="allowClear" class="clear-icon">
        <daz-icon [color]="'#6D6D6D'" [name]="'cross'" [size]="'20px'" (click)="clearInput()"></daz-icon>
    </span>
    <div *ngIf="loading">
        <p-progressSpinner [style]="{'margin-left': '8px', width: '30px', height: '30px' }" strokeWidth="2"
            fill="transparent" animationDuration=".5s">
        </p-progressSpinner>
    </div>
</div>
<div class="error-message" *ngIf="required && !value">{{ errorLabel }}</div>